import { Link } from 'react-router-dom'
import { Clock, MapPin, MessageCircle, ShieldUser } from 'lucide-react'
import { FaFacebookF, FaInstagram, FaTiktok } from 'react-icons/fa6'
import { whatsAppChatUrl } from '@/lib/whatsapp'
import { STORE_WHATSAPP_NUMBER } from '@/lib/env'
import { CarouselMark } from './CarouselMark'

const ADDRESS = 'Calle 48 #51-42, Medellín'
const MAPS_QUERY = encodeURIComponent(`${ADDRESS}, Colombia`)
const MAPS_EMBED_URL = `https://www.google.com/maps?q=${MAPS_QUERY}&output=embed`
const MAPS_LINK_URL = `https://www.google.com/maps/search/?api=1&query=${MAPS_QUERY}`

// Colores de marca de cada red — a propósito fijos (no siguen la paleta del
// sitio), para que cada ícono se reconozca de un vistazo.
const SOCIAL_LINKS = [
  {
    label: 'Instagram',
    href: 'https://instagram.com/magicomundo_carruseldelosninos',
    Icon: FaInstagram,
    className: 'bg-gradient-to-tr from-[#FEDA75] via-[#D62976] to-[#4F5BD5] text-white',
  },
  {
    label: 'TikTok',
    href: 'https://www.tiktok.com/@carrusel88',
    Icon: FaTiktok,
    className: 'bg-black text-white',
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/profile.php?id=100054392116439&locale=es_LA',
    Icon: FaFacebookF,
    className: 'bg-[#1877F2] text-white',
  },
]

export function PublicFooter() {
  return (
    <footer className="mt-16 border-t border-border/70 bg-muted/40">
      <div className="mx-auto grid max-w-6xl gap-8 px-4 py-10 sm:px-6 md:grid-cols-3">
        <div>
          <p className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground">
            <CarouselMark size={24} />
            El mágico mundo del carrusel de los niños
          </p>
          <p className="mt-2 max-w-xs text-sm text-muted-foreground">
            Ropa y accesorios para niños, seleccionados con cariño. Escríbenos y te ayudamos a encontrar lo que buscas.
          </p>

          <div className="mt-4 flex items-center gap-2.5">
            {SOCIAL_LINKS.map(({ label, href, Icon, className }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noreferrer"
                aria-label={label}
                className={`flex size-9 items-center justify-center rounded-full shadow-sm transition-transform hover:scale-105 ${className}`}
              >
                <Icon className="size-4" />
              </a>
            ))}
            <a
              href={whatsAppChatUrl(STORE_WHATSAPP_NUMBER)}
              target="_blank"
              rel="noreferrer"
              aria-label="WhatsApp"
              className="flex size-9 items-center justify-center rounded-full bg-[#25D366] text-white shadow-sm transition-transform hover:scale-105"
            >
              <MessageCircle className="size-4" />
            </a>
          </div>
        </div>

        <div>
          <p className="flex items-center gap-1.5 text-sm font-semibold text-foreground">
            <Clock className="size-4 text-primary" />
            Horarios de atención
          </p>
          <dl className="mt-2 grid gap-1 text-sm text-muted-foreground">
            <div className="flex justify-between gap-4">
              <dt>Lunes a sábado</dt>
              <dd>9:00 am – 6:00 pm</dd>
            </div>
            <div className="flex justify-between gap-4">
              <dt>Temporada</dt>
              <dd>9:00 am – 8:00 pm</dd>
            </div>
          </dl>

          <p className="mt-5 flex items-center gap-1.5 text-sm font-semibold text-foreground">
            <MapPin className="size-4 text-primary" />
            Visítanos
          </p>
          <a
            href={MAPS_LINK_URL}
            target="_blank"
            rel="noreferrer"
            className="mt-1 inline-block text-sm text-muted-foreground hover:text-primary hover:underline"
          >
            {ADDRESS}
          </a>
        </div>

        <div>
          <iframe
            title="Ubicación de la tienda en Google Maps"
            src={MAPS_EMBED_URL}
            className="h-40 w-full rounded-xl border border-border sm:h-full sm:min-h-40"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>

      <div className="border-t border-border/70">
        <div className="mx-auto flex max-w-6xl flex-col items-center gap-2 px-4 py-4 text-center text-xs text-muted-foreground sm:flex-row sm:justify-between sm:px-6 sm:text-left">
          <span>
            © {new Date().getFullYear()} El mágico mundo del carrusel de los niños · Hecho por{' '}
            <a
              href="https://digitalportalix.com/"
              target="_blank"
              rel="noreferrer"
              className="font-medium hover:text-foreground hover:underline"
            >
              Portalix
            </a>
          </span>
          <Link to="/login" className="flex shrink-0 items-center gap-1 hover:text-foreground">
            <ShieldUser className="size-3.5" />
            Administrador
          </Link>
        </div>
      </div>
    </footer>
  )
}
